import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import { Box, Chip, ListItemButton, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import AssignedViaDeviceGroupChip from './AssignedViaDeviceGroupChip';
import { Group } from './GroupCard';

interface Props {
  group: Group;
  onClick: () => void;
}

const GroupRow: React.FC<Props> = ({ group, onClick }) => {
  const theme = useTheme();
  const { translation } = useTranslation();
  const deviceGroups = group.viaDeviceGroups ?? [];
  const hasDeviceGroups = deviceGroups.length > 0;
  const hasChips = group.isIncomplete || hasDeviceGroups;

  return (
    <ListItemButton
      id={`group-${group.id}-row`}
      sx={{ backgroundColor: theme.custom.background.level2, borderRadius: '4px' }}
      onClick={onClick}
    >
      <Stack
        direction="row"
        flexWrap="wrap"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        minWidth={0}
        rowGap={0.5}
        columnGap={1}
      >
        <Tooltip title={group.name} placement="top">
          <Box minWidth={0} overflow="hidden">
            <Typography variant="body1" noWrap>
              {group.name}
            </Typography>
          </Box>
        </Tooltip>
        {hasChips && (
          <Stack
            direction="row"
            flexWrap="wrap"
            alignItems="center"
            rowGap={0.5}
            columnGap={1}
            sx={{ maxWidth: '100%', minWidth: 0 }}
          >
            {group.isIncomplete && (
              <Chip
                label={translation.incomplete}
                color="warning"
                size="small"
                icon={<WarningAmberOutlined />}
                sx={{
                  '& .MuiChip-label': { color: theme.palette.warning.light },
                  '& .MuiChip-icon': { color: theme.palette.warning.main }
                }}
              />
            )}
            {hasDeviceGroups && <AssignedViaDeviceGroupChip deviceGroups={deviceGroups} />}
          </Stack>
        )}
      </Stack>
    </ListItemButton>
  );
};

export default GroupRow;
